/**
 * JSON Type Detector
 */

import { SEMANTIC_TYPES } from '@/detectors/semanticTypes';
import type { ISemanticType } from '@/interfaces/ISemanticType';
import type { ITypeDetector } from '@/interfaces/ITypeDetector';

export const JsonDetector: ITypeDetector = {
  id: 'json-detector',
  name: 'JSON Detector',
  priority: 60,
  detectedType: SEMANTIC_TYPES.JSON,

  detect(input: string): ISemanticType | null {
    const trimmed = input.trim();
    
    // Quick check: must start with { or [
    if (!trimmed.startsWith('{') && !trimmed.startsWith('[')) {
      return null;
    }

    try {
      JSON.parse(trimmed);
      return SEMANTIC_TYPES.JSON;
    } catch {
      return null;
    }
  },
};
